import React, { Component } from 'react';
import Select from 'react-select';

class CanalizadosComponent extends Component {
    onChangeBuilding = async (event) => {
        const { props } = this.props
        const { searchData, refreshSearch, search } = props
        let value = null
        if (event && event.value !== undefined) {
            value = event.value;
        }
        else if (event && event.nativeEvent && event.nativeEvent.target) {
            value = event.nativeEvent.target.value;
        }
        searchData.building = value;
        refreshSearch(searchData);
        search(searchData);
    }
    render() {
        const { props, state } = this.props
        const { searchData } = props
        return (
            <div className="d-inline-flex flex-wrap align-items-start">
                <div className="mr-3 mb-2">
                    <Select
                        menuPlacement="auto"
                        options={props?.listBuilding ?? []}
                        value={(props?.listBuilding ?? []).find(building => building.value === searchData.building) || null}
                        onChange={this.onChangeBuilding}
                        placeholder="Edificio..."
                        isSearchable
                        isClearable
                        menuPortalTarget={document.body}
                        noOptionsMessage={() => 'No se encontraron coincidencias'}
                        styles={{
                            container: (base) => ({ ...base, flex: 1, width: 320 }),
                            control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                            input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                            singleValue: (base) => ({ ...base, color: "#000" })
                        }}
                    />
                </div>

            </div>
        );
    }
}

export default CanalizadosComponent;
